// extracted by mini-css-extract-plugin
export default {"modal":"LogIn_modal__S9R32","SignIn_Page":"LogIn_SignIn_Page__he1N9","SignIn_footer":"LogIn_SignIn_footer__mxbyC","loginLink":"LogIn_loginLink__pqlo7","error":"LogIn_error__5Wgpx"};